<ng-container [ngSwitch]="column.type">

	<ng-container *ngSwitchCase="'image'">
		<div class="container-image" *ngIf="dataField">
			<img [src]="dataField.url">
			<span>{{getDate(dataField) | date:'d MMMM y, h:mm:ss a'}}</span>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="'bw_gb'">
		{{ formatBw(dataField) }}
	</ng-container>

	<ng-container *ngSwitchCase="'connection_status'">
		<span
		class="status-dot"
		[ngClass]="getConnectionStatus(dataField)"
		[title]="getConnectionTooltip(dataField)">
		</span>
	</ng-container>
	<ng-container *ngSwitchCase="'connection'">
		<span
		class="status-dot"
		[ngClass]="getConnectionStatus(dataField)"
		[title]="getConnectionTooltip(dataField)">
		</span>
	</ng-container>
	<ng-container *ngSwitchCase="'date'">
		{{ formatDate(dataField) }}
	</ng-container>
	<ng-container *ngSwitchDefault>
		{{ dataField || column?.default || '-' }}
	</ng-container>

</ng-container>
